/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
  auth: {
    clientId: "529da764-38de-44aa-8422-8a347b603e7f",
    authority:
      "https://login.microsoftonline.com/415583d5-7eaf-4a15-9726-25f62ad4a1a2",
    redirectUri: process.env.REACT_APP_FRONTEND_BASE_URL,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        // console.log(
        //   "authConfig level message containsPii",
        //   level,
        //   message,
        //   containsPii
        // );

        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read", "Directory.Read.All"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMemberOfEndpoint: `https://graph.microsoft.com/v1.0/me/memberOf/microsoft.graph.group?$count=true&$orderby=displayName&$select=displayName,id`,
  graphJoinedTeamsEndpoint: `https://graph.microsoft.com/v1.0/me/joinedTeams`,
  graphProfilePhoto: "https://graph.microsoft.com/v1.0/me/photo",
  graphPeople: "https://graph.microsoft.com/v1.0/me/users",
  graphMemberOf:
    "https://graph.microsoft.com/v1.0/users/af9f9305-cf86-4585-b7eb-fb0fe28d9e46/memberOf",
  groupById:
    "https://graph.microsoft.com/v1.0/groups/e58d6b8a-763b-4671-a71c-5ea3f942ade9/members",
};
